import {Inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import * as _ from 'lodash';

@Pipe({
  standalone: false,
  name: 'bringozVolume'
})
export class BringozVolumePipe implements PipeTransform {

  constructor(@Inject(TranslateService) private translateService: TranslateService, @Inject('splitService') private splitService) {
  }

  transform(volume: number, enableUnitDisplay: boolean, defaultValue: string = '--'): string {
    const siteUnit = this.splitService.getVolumeUnit();

    if (_.isUndefined(volume)) {
      return defaultValue;
    }

    const volumeUnit = this.translateService.instant(siteUnit);
    return _.round(volume, 2) + (enableUnitDisplay ? (' ' + volumeUnit) : '');
  }
}
